var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB2BProject1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2192.24 1474.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#bdd0fb;}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:#18174a;}.cls-9{fill:#2b69b3;}.cls-10{fill:#7d97f4;}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:url(#linear-gradient-8);}.cls-14{fill:url(#linear-gradient-9);}.cls-15{fill:url(#linear-gradient-10);}.cls-16{fill:url(#linear-gradient-11);}.cls-17{fill:url(#linear-gradient-12);}.cls-18,.cls-30,.cls-54{fill:#fff;}.cls-18{opacity:0.7;}.cls-19{fill:url(#linear-gradient-13);}.cls-20{fill:url(#linear-gradient-14);}.cls-21{fill:url(#linear-gradient-15);}.cls-22{fill:url(#linear-gradient-16);}.cls-23{fill:url(#linear-gradient-17);}.cls-24{fill:url(#linear-gradient-18);}.cls-25{fill:url(#linear-gradient-19);}.cls-26{fill:url(#linear-gradient-20);}.cls-27{fill:url(#linear-gradient-21);}.cls-28{fill:url(#linear-gradient-22);}.cls-29{fill:url(#linear-gradient-23);}.cls-30{opacity:0.69;}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#linear-gradient-29);}.cls-37{fill:url(#linear-gradient-30);}.cls-38{fill:url(#linear-gradient-31);}.cls-39{fill:url(#linear-gradient-32);}.cls-40{fill:url(#linear-gradient-33);}.cls-41{fill:url(#linear-gradient-34);}.cls-42{fill:url(#linear-gradient-35);}.cls-43{fill:url(#linear-gradient-36);}.cls-44{fill:url(#linear-gradient-37);}.cls-45{fill:url(#linear-gradient-38);}.cls-46{fill:url(#linear-gradient-39);}.cls-47{fill:url(#linear-gradient-40);}.cls-48{fill:url(#linear-gradient-41);}.cls-49{fill:url(#linear-gradient-42);}.cls-50{fill:url(#linear-gradient-43);}.cls-51{fill:url(#linear-gradient-44);}.cls-52{fill:url(#linear-gradient-45);}.cls-53{fill:url(#linear-gradient-46);}.cls-55{fill:url(#linear-gradient-47);}.cls-56{fill:url(#linear-gradient-48);}.cls-57{fill:url(#linear-gradient-49);}.cls-58{fill:url(#linear-gradient-50);}.cls-59{fill:url(#linear-gradient-51);}.cls-60{fill:url(#linear-gradient-52);}.cls-61{fill:url(#linear-gradient-53);}.cls-62{fill:url(#linear-gradient-54);}.cls-63{fill:url(#linear-gradient-55);}.cls-64{fill:url(#linear-gradient-56);}.cls-65{fill:url(#linear-gradient-57);}.cls-66{fill:url(#linear-gradient-58);}.cls-67{fill:url(#linear-gradient-59);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 864.96,
    y1: -112.82,
    x2: 1462.1,
    y2: 1579.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 97.7,
    y1: 1026.68,
    x2: 396.73,
    y2: 1026.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1816.02,
    y1: 1117.39,
    x2: 2133.55,
    y2: 1117.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1736.44,
    y1: 927.53,
    x2: 2034.93,
    y2: 927.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 260.08,
    y1: 763.87,
    x2: 588.29,
    y2: 763.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1818.54,
    y1: 1307.22,
    x2: 1939.47,
    y2: 1433.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1722.2,
    y1: 1442.15,
    x2: 1836.19,
    y2: 1286.53,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1053.75,
    y1: 1068.81,
    x2: 1152.89,
    y2: 1284.6,
    gradientTransform: "translate(855.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1887.39,
    y1: 976.49,
    x2: 1916.13,
    y2: 1072.64,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1437.01,
    y1: 525.07,
    x2: 1380.51,
    y2: 591.48,
    gradientTransform: "translate(855.49)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1453.12,
    y1: 538.77,
    x2: 1396.62,
    y2: 605.18,
    gradientTransform: "translate(855.49)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2098.15,
    y1: 918.27,
    x2: 2002.99,
    y2: 1087.78,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1313.46,
    y1: 196.01,
    x2: 1271.83,
    y2: 459.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1339.06,
    y1: 200.05,
    x2: 1297.43,
    y2: 463.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1360.98,
    y1: 203.51,
    x2: 1319.35,
    y2: 467.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1392.79,
    y1: 208.54,
    x2: 1351.16,
    y2: 472.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1323.63,
    y1: 197.62,
    x2: 1282,
    y2: 461.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1346.72,
    y1: 201.26,
    x2: 1305.09,
    y2: 464.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1364.2,
    y1: 204.02,
    x2: 1322.57,
    y2: 467.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1378.56,
    y1: 206.29,
    x2: 1336.93,
    y2: 469.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1397.43,
    y1: 209.27,
    x2: 1355.8,
    y2: 472.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1417.8,
    y1: 212.48,
    x2: 1376.17,
    y2: 476.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1120.18,
    y1: 923.39,
    x2: 1016.11,
    y2: 1269.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1187.02,
    y1: 943.47,
    x2: 1082.95,
    y2: 1289.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -6086.2,
    y1: -76.01,
    x2: -6190.27,
    y2: 270.39,
    gradientTransform: "matrix(-1, 0, 0, 1, -5486.56, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1839.37,
    y1: 26.8,
    x2: 1585.62,
    y2: 736.49,
    gradientTransform: "translate(703.98 -1160.25) rotate(45)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 639.66,
    y1: 1330.97,
    x2: 229.39,
    y2: 2044.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 921.44,
    y1: 590.94,
    x2: 775.55,
    y2: 858.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 793.95,
    y1: 1419.68,
    x2: 383.67,
    y2: 2133.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1444.05,
    y1: 414.43,
    x2: 1399.45,
    y2: 527.42,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1459.76,
    y1: 420.63,
    x2: 1415.16,
    y2: 533.62,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 917.31,
    y1: 637.79,
    x2: 840.11,
    y2: 971.41,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 915.21,
    y1: 486.32,
    x2: 900.34,
    y2: 643.91,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 866.09,
    y1: 481.68,
    x2: 851.22,
    y2: 639.28,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1972.2,
    y1: 588.7,
    x2: 1922.64,
    y2: 830.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 2004.49,
    y1: 595.31,
    x2: 1954.93,
    y2: 837.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 2032.34,
    y1: 601.02,
    x2: 1982.78,
    y2: 842.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 2067.29,
    y1: 608.18,
    x2: 2017.73,
    y2: 850.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 2097,
    y1: 614.27,
    x2: 2047.44,
    y2: 856.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 2121.41,
    y1: 619.27,
    x2: 2071.85,
    y2: 861.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1823.08,
    y1: 567.61,
    x2: 1706.12,
    y2: 769.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1861.28,
    y1: 589.71,
    x2: 1744.32,
    y2: 791.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1889.89,
    y1: 606.25,
    x2: 1772.93,
    y2: 808.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1474.32,
    y1: 558.66,
    x2: 1440.62,
    y2: 1000.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1514.7,
    y1: 561.74,
    x2: 1481,
    y2: 1003.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1552.7,
    y1: 564.64,
    x2: 1519,
    y2: 1006.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 133.71,
    y1: 1247.87,
    x2: 509.98,
    y2: 1247.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 133.71,
    y1: 1258.17,
    x2: 509.98,
    y2: 1258.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 133.71,
    y1: 1268.46,
    x2: 509.98,
    y2: 1268.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 133.71,
    y1: 1278.76,
    x2: 509.98,
    y2: 1278.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 133.71,
    y1: 1289.06,
    x2: 509.98,
    y2: 1289.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 5930.7,
    y1: 1393.69,
    x2: 5953.67,
    y2: 1393.69,
    gradientTransform: "translate(-5408.16)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 6039.49,
    y1: 1395.62,
    x2: 6066.91,
    y2: 1395.62,
    gradientTransform: "translate(-5408.16)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 523.87,
    y1: 958.14,
    x2: 442.88,
    y2: 1049.64,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 341.8,
    y1: 1093.67,
    x2: 607.33,
    y2: 1093.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 470.9,
    y1: 1076.31,
    x2: 491.41,
    y2: 1076.31,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 6007.24,
    y1: 1144.44,
    x2: 6070.58,
    y2: 1144.44,
    gradientTransform: "translate(-5408.16)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 5513.62,
    y1: 3364.68,
    x2: 5447.66,
    y2: 3451.95,
    gradientTransform: "translate(-5394.33 -1598.31) rotate(-8.21)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 551.81,
    y1: 888.72,
    x2: 438.82,
    y2: 1061.18,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2105.33,278.36c-25.88-19.49-53.93-37.26-64.79-66.85-9.24-25.18-3.59-53.48-9.74-79.59C2022.53,96.86,1994,70,1963.13,51.4,1898.33,12.3,1819.78,1,1744.25,5.92S1595.12,31,1522.13,51C1409.47,81.94,1296.62,109,1189,153.67S991.41,215,876.75,184.91C744.29,150.21,611.51,53.7,471.14,74.77,398.76,85.64,330.75,132,301.44,199.1c-12.43,28.46-18.27,60.37-37.09,85.06C231,327.89,166.8,336.85,130,377.68c-31.35,34.75-36.63,87.05-25.17,132.42,10.74,42.54,36.22,75.83,54.45,114.75,14.5,30.94,39.67,59.53,50.38,91.84,11.69,35.24.91,73.55-9.87,109.08-18.13,59.78-52.41,114.89-53.93,177.94-1.58,66.16,22.33,128.51,68.59,176,19.6,20.12,74.28,20.29,99.54,24,73.43,10.66,147.49,17.35,221.39,23.7,180.2,15.46,366.79,37.64,547,29.16,67.29-3.17,134.16,5.91,201.36,5.32,64.06-.56,128.45-8,192.62-10.09,137-4.49,275.24-5.27,409.65-35.09,37.89-8.41,75.24-19.08,112.42-30.2,65.18-19.51,135.54-44.72,170.41-103.14,34.63-58,23.83-131.28,11.92-197.79-12.25-68.44-33-140.44-37.24-209.8-3.55-58-26.05-119.18-19.14-177.84,7.59-54.73,51-115.33,25.79-170.75C2140.91,306.83,2123.66,292.16,2105.33,278.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.78,721.88c-3.62,72.67-7.42,496.46,389.61,571.46,0,0,74.32-278.35-380.09-576.32A6.16,6.16,0,0,0,57.78,721.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101,781.81c7.45,22.69,15.82,45.14,24.51,67.42s18,44.35,27.68,66.22,19.9,43.52,30.59,64.91,21.82,42.57,33.68,63.33c23.59,41.57,49.49,81.85,78.66,119.63,3.54,4.8,7.43,9.32,11.13,14l5.63,7c1.87,2.32,3.88,4.53,5.81,6.8,3.92,4.48,7.75,9,11.74,13.46l12.18,13.07a536.29,536.29,0,0,0,52.61,48.07l0,0a3.95,3.95,0,0,1-4.9,6.19l0,0a545.41,545.41,0,0,1-53-49.22l-12.22-13.33c-4-4.49-7.83-9.14-11.76-13.7-1.94-2.31-3.94-4.55-5.82-6.91l-5.62-7.06c-3.7-4.74-7.59-9.34-11.12-14.21-29.11-38.33-54.84-79-78.2-121-11.75-20.94-22.71-42.31-33.3-63.84s-20.64-43.33-30.17-65.34S130.42,873,121.84,850.65s-16.75-44.94-24.06-67.84a1.66,1.66,0,0,1,1.08-2.1,1.68,1.68,0,0,1,2.1,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2174.41,868c-6.18,67.32-56.89,457.05-402.89,460.93,0,0-27.56-267.74,395.45-466.94C2170.67,860.22,2174.82,863.59,2174.41,868Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2133.36,917.51C2124.45,937,2114.85,956,2104.94,975s-20.28,37.58-31,56.06-21.87,36.69-33.42,54.67-23.48,35.72-36,53-25.37,34.45-39,51-27.62,32.75-42.59,48.11c-29.71,30.89-62.54,59.19-99.51,81.68a4.88,4.88,0,1,1-5.08-8.34h0l.08-.05c36.19-21.47,68.82-48.91,98.49-79.11,15-15,29-30.92,42.69-47.15s26.66-33.07,39.27-50.17,24.7-34.6,36.38-52.37,23-35.8,33.87-54.08,21.4-36.79,31.5-55.53,19.88-37.66,28.93-56.86v0a2.07,2.07,0,0,1,3.75,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2072.76,518.38c17.81,88.35,100.51,606.71-372,771.68,0,0-142.29-327.24,359.43-775.87A7.63,7.63,0,0,1,2072.76,518.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2034.9,600.34c-4.51,30.08-10.31,59.85-16.65,89.53s-13.45,59.2-21.29,88.53-16.41,58.45-25.75,87.35c-2.39,7.2-4.64,14.46-7.15,21.62l-7.46,21.53c-5.24,14.25-10.37,28.55-16,42.65-5.42,14.19-11.46,28.14-17.36,42.15l-9.33,20.81c-3,7-6.52,13.73-9.75,20.61-13.28,27.36-27.52,54.3-43.58,80.2l-5.94,9.75-6.29,9.55-6.28,9.55-3.15,4.77-3.33,4.64-13.38,18.56-14.2,18a518.92,518.92,0,0,1-63.82,65.76,4.67,4.67,0,1,1-6.07-7.1l0,0,.05,0a511.09,511.09,0,0,0,63.12-64.1l14.12-17.6,13.35-18.23,3.32-4.56,3.15-4.69,6.28-9.4,6.29-9.39,6-9.62c16.09-25.51,30.41-52.14,43.8-79.21,3.27-6.8,6.77-13.5,9.84-20.4l9.43-20.61c6-13.89,12.08-27.71,17.58-41.8,5.75-14,10.95-28.18,16.28-42.34l7.59-21.38c2.55-7.11,4.84-14.32,7.28-21.48q14.28-43.08,26.31-86.88t21.89-88.13c6.53-29.54,12.55-59.26,17.25-89.11v0a2,2,0,0,1,3.91.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.79,161.29c-37.3,122.32-225.31,843,419.27,1140.9,0,0,245.91-442.59-401-1145.1A10.81,10.81,0,0,0,216.79,161.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M263.49,282c2.51,42.85,6.8,85.66,11.94,128.32s11.37,85.2,18.63,127.55c14.54,84.7,33.09,168.74,57.09,251.22s53.49,163.42,91.39,240.39c9.41,19.27,19.55,38.16,30.15,56.77s21.88,36.85,33.85,54.59a690.69,690.69,0,0,0,80.57,99.6l0,0a4,4,0,1,1-5.76,5.64v0a698,698,0,0,1-81-101.09q-18-26.94-33.88-55.19c-10.6-18.8-20.73-37.87-30.1-57.29-37.78-77.61-66.94-159.07-90.71-241.84s-41.91-167.14-56.09-252Q278.93,475,271.46,410.82c-4.95-42.76-9.06-85.6-11.37-128.64a1.7,1.7,0,1,1,3.4-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1813.88,1224a25.51,25.51,0,0,1-25.45,25.42H412.2A25.52,25.52,0,0,1,386.75,1224L375.3,433.11c0-14,16.48-41.29,46.67-39.24l1345-34.8a64.14,64.14,0,0,1,65.81,65.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1788.75,1199.59a24.14,24.14,0,0,1-24.07,24.08H445.39a24.14,24.14,0,0,1-24.07-24.08l-10.81-718c1.27-43.21,39.15-58.74,62.11-57.82l1289.1-34.59a45,45,0,0,1,46.21,46.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M435.57,857.25A2.27,2.27,0,0,1,433.3,855l-.85-58.22a2.27,2.27,0,1,1,4.54-.07l.86,58.23a2.28,2.28,0,0,1-2.24,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M433.48,714.57a2.27,2.27,0,0,1-2.27-2.24l-3.28-223c.07-15,4.69-27,13.74-35.64,16.44-15.75,42.15-15,43.23-14.92l411.64-11a2.23,2.23,0,0,1,2.33,2.21,2.28,2.28,0,0,1-2.21,2.33L484.89,443.31c-1.17-.05-25-.78-40.08,13.66-8.12,7.78-12.27,18.66-12.33,32.33l3.27,223a2.27,2.27,0,0,1-2.24,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M514.8,1059.66c1.18-50.31.74-495.82-2.15-534.29s57-45.7,149-50,868.25-21.47,888.23-23.09c44.93-3.64,54.23,63.51,49.73,209.28-3.37,109.53-9,289.94-11.54,372.91a45.79,45.79,0,0,1-45.68,44.38c-186.8.51-902.73,2.56-950.39,4C537.19,1084.43,514.34,1079.6,514.8,1059.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1890.78,1315.06h-1553A34.84,34.84,0,0,1,303,1280.32h0a34.85,34.85,0,0,1,34.74-34.75h1553a34.86,34.86,0,0,1,34.75,34.75h0A34.85,34.85,0,0,1,1890.78,1315.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1935.37,
    y: 1312.53,
    width: 12.44,
    height: 134.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1889.75,1441.51h103.67a2.62,2.62,0,0,1,2.62,2.62v5.47a0,0,0,0,1,0,0H1887.13a0,0,0,0,1,0,0v-5.47A2.62,2.62,0,0,1,1889.75,1441.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1875.27,
    y: 1282.4,
    width: 136.94,
    height: 38.84,
    rx: 13.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1849.78,1222.86s-18.47,2.86-39.25,16.75a10.37,10.37,0,0,0-4.57,9.9c2.49,19.71,12.72,83.49,46.45,145.78a15.7,15.7,0,0,1,1.5,10.76l-5.86,27.27-10.87,10.19h28l18.64-50.43-8-2.52a15.08,15.08,0,0,1-10.53-14.12l-.93-54.1c.79-24.11-14.78-40.74-14.78-40.74l44.7-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1826.25,1448.43c-2.55,3.34,27.44,7.74,42.59.44,0,0,21-36.53,21-55.35,0,0-1.67-3.83-14-3,0,0-7,43.26-14.49,48.11s-20.84.49-20.84.49S1830,1443.51,1826.25,1448.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1888.64,1282.4c-.23-.42-48.13-5.76-48.13-5.76s1.57,14.56-3.33,34.6-75.21,106.9-75.21,106.9l7.37,23.37c-22.79,7.94-45.22,9.21-67.28,4l45.69-27.42s42.76-145.73,69-171.73l48-16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1996.05,1197.6s27.59,41,29.85,59.76-7.55,26.33-36.51,27.59-106.24,1.23-106.24,1.23l-66-56.38s48.07-17.15,60.57-22S1996.05,1197.6,1996.05,1197.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1766.56,1433.64s7.93,7.68,2.57,16.24c0,0-62.88,11.14-80,6.09,0,0,3.55-8.09,22.77-17.3l-1.42,1.09a2.3,2.3,0,0,0,1.52,4.12C1724.72,1443.15,1750.93,1440.83,1766.56,1433.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.42,1002.72c0,3.78,34,143.6,34,143.6l96.9,28.5a43.52,43.52,0,0,0,49.12-18.57h0a87.57,87.57,0,0,0-27.5-120.81l-13.73-8.63A257.63,257.63,0,0,1,1949,956l-5.17-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1921.43,1192.17s-32.14-30.6-48-50.86a43,43,0,0,1-7.28-38.7c7.22-24.33,20-49.52,21.22-53.44,1.8-6,37.82-5.77,37.82-5.77s70.9,46,98.75,124l-31.28,9.74s-18.51-31.06-36.8-50.8c0,0,31.65,41.8,32.76,58.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1883.07,1015.57c.37,1.25,9.77,32.42,10.51,33.07s20.62,1.72,30-4.68l-15.88-33.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1898.51,950.09s-17,7.17-28.52,31.7-2.92,35.86,7.91,37.41,27,1.32,44.14-14.52S1920.58,941.6,1898.51,950.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1910.53,991.58s12.81-35.89-19-36.31L1884,960.5s-11.67-19.9,7.49-29.4,47.75-1,55.91,24.78,3.38,42.48-10.19,54.84-19.15-1.66-19.15-1.66,7.38-11.55,4.38-17.73-10,1.28-10,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1914.1,995.58s6.48-18.49,15.11-11.13-7,17.08-13.15,20.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1856,1194.44l23.6-22.75,32.66,13.79s32.51,5,51.12,0l18.6-5,42-13.09,6.61,18.66a11.23,11.23,0,0,1-4.11,12.91,74.12,74.12,0,0,1-10.62,6.61c-5.53,2.43-136.48-1.67-136.48-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2049.47,1138.12a.7.7,0,0,0,.36-.1c11.94-7.18,13.09-23.29,13-29.88a76.28,76.28,0,0,0-9.91-36.84c-11.4-20.09-31-33.67-50-46.81l-3.9-2.71c-19.15-13.32-40.3-29.49-48.87-52.79a.7.7,0,1,0-1.31.48c8.7,23.69,30,40,49.38,53.46l3.9,2.71c18.85,13,38.33,26.54,49.57,46.35a74.86,74.86,0,0,1,9.73,36.17c.06,6.35-1,21.86-12.36,28.66a.71.71,0,0,0-.24,1A.72.72,0,0,0,2049.47,1138.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2041.61,1117.32a.69.69,0,0,0,.68-.56c2.59-13.15,2.2-24.92-1.16-35-6.07-18.15-22.1-31.3-35.38-40.72-2.65-1.88-5.34-3.73-8-5.58-12.12-8.35-24.67-17-33.72-28.68a.69.69,0,0,0-1-.12.7.7,0,0,0-.13,1c9.19,11.87,21.82,20.56,34,29,2.69,1.85,5.37,3.69,8,5.57,13.11,9.3,28.92,22.26,34.86,40,3.28,9.81,3.66,21.34,1.12,34.25a.69.69,0,0,0,.55.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1945.31,1205.17H1945l-136.94-.15a6.13,6.13,0,1,1,0-12.26l136.94.15a6.13,6.13,0,0,1,.31,12.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1684.94,1080.83h114a21.75,21.75,0,0,1,19.66,12.47l52.72,111.8H1729.64a13.21,13.21,0,0,1-12.28-8.36l-40.89-103.45A9.11,9.11,0,0,1,1684.94,1080.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1765.29,1138.15c2.47,7.68.64,15.14-4.08,16.66s-10.56-3.47-13-11.15-.64-15.14,4.08-16.66S1762.82,1130.48,1765.29,1138.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1591.73,1475a5,5,0,0,1-2-.42,5.19,5.19,0,0,1-2.63-6.74l105.18-250.16a5,5,0,0,1,6.59-2.69,5.19,5.19,0,0,1,2.63,6.74l-105.18,250.16A5,5,0,0,1,1591.73,1475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1710.21,1475a5,5,0,0,1-4.6-3.11L1600.43,1221.7a5.17,5.17,0,0,1,2.62-6.74,5,5,0,0,1,6.59,2.69l105.18,250.16a5.18,5.18,0,0,1-2.63,6.74A4.93,4.93,0,0,1,1710.21,1475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2005.9,1475a5,5,0,0,1-2-.42,5.18,5.18,0,0,1-2.62-6.74l105.18-250.16a5,5,0,0,1,6.59-2.69,5.18,5.18,0,0,1,2.62,6.74l-105.18,250.16A5,5,0,0,1,2005.9,1475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2124.39,1475a5,5,0,0,1-4.61-3.11L2014.6,1221.7a5.18,5.18,0,0,1,2.63-6.74,5,5,0,0,1,6.59,2.69L2129,1467.81a5.17,5.17,0,0,1-2.62,6.74A5,5,0,0,1,2124.39,1475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2136.71,1210.17a5.08,5.08,0,0,0-1.19-4.38,5.79,5.79,0,0,0-4.36-1.92H1559.7a6.62,6.62,0,0,0-5.48,2.81,5.76,5.76,0,0,0-.43,5.84l6.2,12.57a8.72,8.72,0,0,0,7.87,4.71h559.38a6.47,6.47,0,0,0,6.45-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1346.24,
    cy: 284.47,
    r: 100.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1347.04,
    cy: 283.5,
    r: 84.05,
    transform: "translate(856.75 1569.77) rotate(-81.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1310.4,258a16.52,16.52,0,0,1-.66,4.84,10.08,10.08,0,0,1-2,3.68,8.54,8.54,0,0,1-3.27,2.33,11.81,11.81,0,0,1-4.55.81,18,18,0,0,1-2.34-.14,18.79,18.79,0,0,1-2.39-.45l.3-3.52a1.15,1.15,0,0,1,.37-.78,1.3,1.3,0,0,1,.93-.3,4.25,4.25,0,0,1,1,.15,5.93,5.93,0,0,0,1.53.16,6.3,6.3,0,0,0,2.22-.36,3.79,3.79,0,0,0,1.62-1.16,5.34,5.34,0,0,0,1-2.06,12.27,12.27,0,0,0,.33-3.07V237.49h5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1343.65,269.31h-4.57a2,2,0,0,1-1.27-.38,2.16,2.16,0,0,1-.71-1l-2.38-6.49h-13.18l-2.38,6.49a2.06,2.06,0,0,1-.69.92,2,2,0,0,1-1.27.42h-4.6l12.5-31.82h6.05Zm-20.6-12h10.15l-3.87-10.59c-.18-.47-.37-1-.59-1.66s-.42-1.33-.62-2.08c-.21.75-.41,1.44-.61,2.09s-.39,1.21-.58,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1340.09,237.49h4.77a2,2,0,0,1,1.26.37,2.45,2.45,0,0,1,.73,1l7.48,19.41c.25.63.49,1.33.71,2.08s.45,1.55.65,2.39a27.35,27.35,0,0,1,1.26-4.47l7.46-19.41a2.22,2.22,0,0,1,.7-.92,1.92,1.92,0,0,1,1.26-.42h4.77l-12.85,31.82h-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1398.72,269.31h-4.58a2.06,2.06,0,0,1-1.27-.38,2.16,2.16,0,0,1-.71-1l-2.38-6.49H1376.6l-2.38,6.49a2.06,2.06,0,0,1-.69.92,2,2,0,0,1-1.27.42h-4.6l12.5-31.82h6.06Zm-20.6-12h10.14l-3.87-10.59c-.18-.47-.37-1-.58-1.66s-.43-1.33-.63-2.08c-.21.75-.41,1.44-.61,2.09s-.39,1.21-.58,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1314.65,296.09a1.61,1.61,0,0,1-.56.69,1.46,1.46,0,0,1-.76.2,1.89,1.89,0,0,1-1-.35c-.37-.22-.8-.48-1.3-.76a10.69,10.69,0,0,0-1.75-.75,7.31,7.31,0,0,0-2.37-.35,6.87,6.87,0,0,0-2.14.3,4.36,4.36,0,0,0-1.54.83,3.32,3.32,0,0,0-.94,1.26,4.25,4.25,0,0,0-.31,1.62,2.8,2.8,0,0,0,.63,1.87,5.21,5.21,0,0,0,1.66,1.28,15.89,15.89,0,0,0,2.36.94c.88.28,1.78.58,2.69.89a28.8,28.8,0,0,1,2.7,1.1,9.35,9.35,0,0,1,2.35,1.59,7.1,7.1,0,0,1,1.66,2.34,8.14,8.14,0,0,1,.63,3.37,10.82,10.82,0,0,1-.74,4,9.39,9.39,0,0,1-2.15,3.28,10.25,10.25,0,0,1-3.47,2.2,12.84,12.84,0,0,1-4.69.8,15.7,15.7,0,0,1-3-.29,16.82,16.82,0,0,1-2.83-.85,15.54,15.54,0,0,1-2.53-1.32,13.2,13.2,0,0,1-2.1-1.72l1.72-2.84a2.23,2.23,0,0,1,.58-.52,1.51,1.51,0,0,1,.76-.2,2.11,2.11,0,0,1,1.19.45c.42.3.93.63,1.51,1a12.12,12.12,0,0,0,2,1,8,8,0,0,0,2.83.45,5.82,5.82,0,0,0,3.92-1.2,4.32,4.32,0,0,0,1.38-3.44,3.19,3.19,0,0,0-.62-2.05,5.16,5.16,0,0,0-1.66-1.33,12.48,12.48,0,0,0-2.36-.91c-.88-.25-1.77-.53-2.68-.82a21.14,21.14,0,0,1-2.69-1.06,8.65,8.65,0,0,1-2.35-1.6,7.37,7.37,0,0,1-1.67-2.48,9.58,9.58,0,0,1-.62-3.66,8.73,8.73,0,0,1,2.72-6.32,9.83,9.83,0,0,1,3.26-2,11.79,11.79,0,0,1,4.43-.77,14.77,14.77,0,0,1,5.19.88,11.65,11.65,0,0,1,4,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1336.76,304.33a2.69,2.69,0,0,1-.47.48,1.07,1.07,0,0,1-.67.18,1.47,1.47,0,0,1-.81-.26c-.27-.17-.58-.36-1-.57a7.34,7.34,0,0,0-1.31-.57,6,6,0,0,0-1.88-.25,5.8,5.8,0,0,0-2.51.51,4.7,4.7,0,0,0-1.79,1.49,6.55,6.55,0,0,0-1.07,2.34,12.4,12.4,0,0,0-.35,3.12,12.08,12.08,0,0,0,.38,3.21,7,7,0,0,0,1.11,2.37,4.9,4.9,0,0,0,1.76,1.45,5.36,5.36,0,0,0,2.34.49,5.66,5.66,0,0,0,2.1-.32,6.28,6.28,0,0,0,1.35-.7c.37-.26.69-.49,1-.7a1.41,1.41,0,0,1,.91-.32,1.09,1.09,0,0,1,1,.5l1.56,2a9.48,9.48,0,0,1-2,1.77,11,11,0,0,1-2.19,1.15,10.53,10.53,0,0,1-2.35.6,16.16,16.16,0,0,1-2.4.18,10,10,0,0,1-3.93-.78,9.14,9.14,0,0,1-3.23-2.28,11.06,11.06,0,0,1-2.18-3.66,14.34,14.34,0,0,1-.8-4.94,14.51,14.51,0,0,1,.71-4.61,10.37,10.37,0,0,1,2.11-3.68,9.62,9.62,0,0,1,3.43-2.43,11.74,11.74,0,0,1,4.71-.88,11.23,11.23,0,0,1,4.43.81,11,11,0,0,1,3.43,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1341.89,322.13V299.55h3.19a1.69,1.69,0,0,1,1.17.31,1.74,1.74,0,0,1,.44,1.05l.33,2.73a10.79,10.79,0,0,1,2.84-3.3,6,6,0,0,1,3.65-1.21,4.72,4.72,0,0,1,2.77.77l-.7,4.07a.82.82,0,0,1-.29.57,1,1,0,0,1-.59.16,3.77,3.77,0,0,1-.9-.15,5.69,5.69,0,0,0-1.52-.16,4.59,4.59,0,0,0-2.91.94,7.2,7.2,0,0,0-2,2.74v14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1366.47,293a3.1,3.1,0,0,1-.28,1.32,3.76,3.76,0,0,1-.76,1.08,3.85,3.85,0,0,1-1.11.74,3.49,3.49,0,0,1-1.37.27,3.33,3.33,0,0,1-1.33-.27,3.62,3.62,0,0,1-1.09-.74,3.7,3.7,0,0,1-.74-1.08,3.25,3.25,0,0,1-.27-1.32,3.47,3.47,0,0,1,2.1-3.2,3.34,3.34,0,0,1,1.33-.28,3.49,3.49,0,0,1,1.37.28,3.66,3.66,0,0,1,1.11.74,3.48,3.48,0,0,1,.76,1.1A3.28,3.28,0,0,1,1366.47,293Zm-.81,6.58v22.58h-5.44V299.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1371.8,329.5V299.55h3.32a1.65,1.65,0,0,1,.91.24,1.14,1.14,0,0,1,.48.75l.44,2.09a11.4,11.4,0,0,1,3.14-2.53,8.56,8.56,0,0,1,4.14-1,7.43,7.43,0,0,1,3.38.77,7.61,7.61,0,0,1,2.64,2.24,10.54,10.54,0,0,1,1.72,3.61,18.29,18.29,0,0,1,.6,4.91,15.32,15.32,0,0,1-.68,4.69,11.18,11.18,0,0,1-2,3.74,8.74,8.74,0,0,1-7.07,3.37,8.07,8.07,0,0,1-3.25-.58,8,8,0,0,1-2.38-1.62v9.24Zm10.56-26.08a5.51,5.51,0,0,0-2.89.72,8.49,8.49,0,0,0-2.23,2v10.13a5.1,5.1,0,0,0,2,1.59,6.1,6.1,0,0,0,2.34.45,5.28,5.28,0,0,0,2.24-.46,4.39,4.39,0,0,0,1.69-1.41,7,7,0,0,0,1.07-2.39,13.6,13.6,0,0,0,.37-3.4,14.57,14.57,0,0,0-.32-3.35,6.43,6.43,0,0,0-.91-2.24,3.64,3.64,0,0,0-1.44-1.25A4.59,4.59,0,0,0,1382.36,303.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1404.11,322.48a5.94,5.94,0,0,1-4.52-1.66,6.41,6.41,0,0,1-1.58-4.59V303.62h-2.29a1.1,1.1,0,0,1-.76-.28,1.12,1.12,0,0,1-.32-.86v-2.16l3.64-.59,1.14-6.17a1.07,1.07,0,0,1,.41-.68,1.29,1.29,0,0,1,.8-.24h2.82v7.11h5.94v3.87h-5.94v12.24a2.42,2.42,0,0,0,.52,1.65,1.83,1.83,0,0,0,1.41.59,2.6,2.6,0,0,0,.85-.12,3.74,3.74,0,0,0,.59-.25l.46-.25a.75.75,0,0,1,.39-.13.66.66,0,0,1,.4.13,2,2,0,0,1,.33.36l1.63,2.64a8.44,8.44,0,0,1-2.73,1.5A10.38,10.38,0,0,1,1404.11,322.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1076.94,1174.55a31,31,0,0,1-31,31c-17.1,0-34-13-34-30.06s16.85-31.86,34-31.86A31,31,0,0,1,1076.94,1174.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1040.35,1193.6h0a4.11,4.11,0,0,1-4.06-3.68l-2.79-26.08a4.1,4.1,0,0,1,4.4-4.53l2.79.21a4.12,4.12,0,0,1,3.79,4.1v25.87A4.11,4.11,0,0,1,1040.35,1193.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1049.21,1163.23v26.28a4.12,4.12,0,0,0,4.07,4.12h.66a4.1,4.1,0,0,0,4.15-4l1-26.29a4.1,4.1,0,0,0-4.1-4.26h-1.61A4.11,4.11,0,0,0,1049.21,1163.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1142.15,1174.55a23.6,23.6,0,0,1-23.59,23.6c-13,0-25.88-9.88-25.88-22.91s12.85-24.28,25.88-24.28A23.59,23.59,0,0,1,1142.15,1174.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1108.78,1164.39v21a3.3,3.3,0,0,0,3.25,3.29h.53a3.28,3.28,0,0,0,3.32-3.17l.76-21a3.28,3.28,0,0,0-3.28-3.4h-1.29A3.29,3.29,0,0,0,1108.78,1164.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1121.43,1163.69l-1.12,22a1.76,1.76,0,0,0,3,1.32l10.65-11a1.78,1.78,0,0,0,.07-2.38l-9.53-11A1.76,1.76,0,0,0,1121.43,1163.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M950.8,1174.55a23.6,23.6,0,0,0,23.59,23.6c13,0,25.88-9.88,25.88-22.91S987.42,1151,974.39,1151A23.59,23.59,0,0,0,950.8,1174.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M984.17,1164.39v21a3.3,3.3,0,0,1-3.25,3.29h-.53a3.27,3.27,0,0,1-3.32-3.17l-.76-21a3.28,3.28,0,0,1,3.28-3.4h1.29A3.29,3.29,0,0,1,984.17,1164.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M971.52,1163.69l1.12,22a1.76,1.76,0,0,1-3,1.32l-10.65-11a1.78,1.78,0,0,1-.07-2.38l9.53-11A1.76,1.76,0,0,1,971.52,1163.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M861.58,1113.1l.66,4.35c.59,4,5.61,7,11.6,7h630.33c6.44,0,11.66-3.49,11.66-7.8h0c0-4.28-5.14-7.76-11.54-7.8l-631-4.35C866.36,1104.47,860.89,1108.47,861.58,1113.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1030.05,1118.64c-.94-4.74-2.1-9.53-3.22-14.35l-499-3.14c-8.91-.05-15.92,4.62-15,10l.83,5.08c.77,4.66,7.2,8.21,14.88,8.21h502.91C1030.92,1122.43,1030.42,1120.46,1030.05,1118.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1033.59,
    cy: 1112.93,
    r: 14.5,
    transform: "translate(-390.16 1641.94) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1752.54,
    cy: 269.65,
    r: 156.97,
    transform: "translate(322.63 1318.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1751.62,
    cy: 271.83,
    r: 132.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1684.66,349.89V189.41h28.1V349.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1796,349.89h-29.75V215.64h-30.73V189.41h91.22v26.23H1796Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1494.56,137.12a2.77,2.77,0,0,1-2.65-2c-.42-1.44-.81-2.91-1.17-4.37a2.76,2.76,0,1,1,5.35-1.32c.34,1.38.72,2.78,1.12,4.14a2.76,2.76,0,0,1-1.87,3.42A3,3,0,0,1,1494.56,137.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1491,118.86a2.75,2.75,0,0,1-2.74-2.48c-.31-3-.49-6-.54-9a2.76,2.76,0,1,1,5.51-.1c0,2.84.22,5.7.51,8.51a2.75,2.75,0,0,1-2.46,3Zm.2-22.94-.33,0a2.77,2.77,0,0,1-2.41-3.07c.36-3,.84-6,1.44-8.87a2.76,2.76,0,0,1,5.4,1.12c-.57,2.76-1,5.59-1.37,8.41A2.75,2.75,0,0,1,1491.17,95.92Zm5.24-22.33a2.75,2.75,0,0,1-2.59-3.69c1-2.81,2.14-5.62,3.38-8.32a2.75,2.75,0,0,1,5,2.29c-1.17,2.57-2.25,5.22-3.2,7.89A2.77,2.77,0,0,1,1496.41,73.59Zm10.1-20.6a2.69,2.69,0,0,1-1.48-.44,2.74,2.74,0,0,1-.84-3.8c1.61-2.52,3.34-5,5.16-7.37a2.75,2.75,0,0,1,4.37,3.35c-1.72,2.25-3.36,4.6-4.89,7A2.73,2.73,0,0,1,1506.51,53Zm14.43-17.84a2.76,2.76,0,0,1-1.94-4.72c2.13-2.09,4.37-4.13,6.66-6a2.76,2.76,0,0,1,3.53,4.24c-2.18,1.81-4.3,3.74-6.31,5.72A2.77,2.77,0,0,1,1520.94,35.15Zm18-14.21a2.75,2.75,0,0,1-1.46-5.09c2.54-1.58,5.17-3.07,7.83-4.42a2.75,2.75,0,1,1,2.5,4.91c-2.52,1.28-5,2.69-7.42,4.19A2.73,2.73,0,0,1,1539,20.94Zm96.5-6.35a2.69,2.69,0,0,1-1.13-.25c-2.58-1.17-5.24-2.23-7.91-3.17a2.76,2.76,0,0,1,1.83-5.2c2.82,1,5.63,2.12,8.35,3.35a2.76,2.76,0,0,1-1.14,5.27Zm-75.8-3.51a2.75,2.75,0,0,1-.9-5.36c2.82-1,5.72-1.84,8.61-2.57a2.75,2.75,0,1,1,1.34,5.34c-2.73.69-5.48,1.51-8.15,2.44A2.88,2.88,0,0,1,1559.65,11.08Zm54-3.54a3.51,3.51,0,0,1-.55,0c-2.77-.56-5.6-1-8.42-1.33a2.76,2.76,0,0,1,.63-5.48c3,.34,6,.81,8.88,1.4a2.76,2.76,0,0,1-.54,5.46ZM1582,6.08a2.76,2.76,0,0,1-.29-5.5c3-.32,6-.51,9-.58h.06a2.76,2.76,0,0,1,.06,5.51c-2.83.06-5.69.25-8.5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1651.71,23.81a2.78,2.78,0,0,1-1.58-.49c-1.16-.81-2.36-1.61-3.57-2.37a2.76,2.76,0,0,1,3-4.66c1.27.81,2.54,1.65,3.77,2.5a2.76,2.76,0,0,1-1.57,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1694.58,92a2.77,2.77,0,0,1-2.72-2.32c-.22-1.42-.48-2.84-.76-4.22a2.76,2.76,0,1,1,5.4-1.1c.3,1.46.57,3,.81,4.46A2.76,2.76,0,0,1,1695,92,3.11,3.11,0,0,1,1694.58,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1593.27,210.9c-1.17,0-2.39,0-3.59-.06a2.76,2.76,0,0,1,.09-5.51h.09c1.13,0,2.26,0,3.38,0h0c1.65,0,3.33,0,5-.12a2.75,2.75,0,1,1,.27,5.5C1596.78,210.86,1595,210.9,1593.27,210.9Zm-17.42-1.46a2.38,2.38,0,0,1-.46,0c-2.9-.49-5.81-1.11-8.66-1.84a2.76,2.76,0,0,1,1.38-5.34c2.69.7,5.45,1.28,8.2,1.75a2.75,2.75,0,0,1-.46,5.47Zm36.42-.31a2.76,2.76,0,0,1-.5-5.47c2.73-.51,5.48-1.15,8.16-1.9a2.75,2.75,0,1,1,1.47,5.31c-2.83.79-5.72,1.46-8.61,2A3.05,3.05,0,0,1,1612.27,209.13Zm-58.13-5.89a2.72,2.72,0,0,1-1-.21c-2.72-1.11-5.43-2.36-8-3.7a2.75,2.75,0,1,1,2.51-4.9c2.48,1.27,5,2.45,7.62,3.5a2.76,2.76,0,0,1-1,5.31Zm79.7-.73a2.75,2.75,0,0,1-1.09-5.28c2.55-1.11,5.09-2.33,7.54-3.65a2.76,2.76,0,0,1,2.61,4.86c-2.59,1.39-5.27,2.68-8,3.85A2.84,2.84,0,0,1,1633.84,202.51Zm19.61-11.18a2.75,2.75,0,0,1-1.63-5c2.26-1.64,4.47-3.39,6.58-5.21a2.76,2.76,0,0,1,3.6,4.18c-2.23,1.91-4.56,3.76-6.94,5.49A2.76,2.76,0,0,1,1653.45,191.33Zm16.7-15.18a2.75,2.75,0,0,1-2.06-4.58c1.84-2.09,3.62-4.28,5.28-6.51a2.76,2.76,0,0,1,4.42,3.29c-1.75,2.36-3.63,4.67-5.57,6.87A2.76,2.76,0,0,1,1670.15,176.15Zm13-18.45a2.67,2.67,0,0,1-1.33-.35,2.75,2.75,0,0,1-1.08-3.74c1.34-2.44,2.6-5,3.73-7.51a2.76,2.76,0,0,1,5,2.25c-1.19,2.68-2.52,5.35-3.94,7.92A2.75,2.75,0,0,1,1683.15,157.7Zm8.64-20.87a2.61,2.61,0,0,1-.77-.11,2.76,2.76,0,0,1-1.88-3.41c.77-2.67,1.44-5.41,2-8.14a2.75,2.75,0,0,1,5.4,1.08c-.57,2.88-1.28,5.77-2.09,8.59A2.75,2.75,0,0,1,1691.79,136.83Zm3.85-22.24h-.17a2.76,2.76,0,0,1-2.58-2.93c.13-2.1.2-4.22.2-6.31,0-.69,0-1.38,0-2.07a2.74,2.74,0,0,1,2.69-2.81h.06a2.75,2.75,0,0,1,2.76,2.7c0,.72,0,1.45,0,2.18,0,2.2-.07,4.44-.21,6.66A2.75,2.75,0,0,1,1695.64,114.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1534.27,192.38a2.76,2.76,0,0,1-1.58-.5c-1.23-.87-2.46-1.77-3.65-2.68a2.76,2.76,0,1,1,3.36-4.37c1.12.86,2.29,1.71,3.45,2.53a2.76,2.76,0,0,1-1.58,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1537.68,161.56a1.23,1.23,0,0,0,1.38.38l14.08-5.18a65.6,65.6,0,0,0,18.64,10l3.43,14.59a1.26,1.26,0,0,0,1.08,1l17.9,1.81a1.24,1.24,0,0,0,1.25-.71l6.29-13.61a65.32,65.32,0,0,0,20.28-6.1l12.75,7.9a1.23,1.23,0,0,0,1.43-.09l13.94-11.38a1.23,1.23,0,0,0,.38-1.38l-5.18-14.08a65.24,65.24,0,0,0,10-18.64l14.6-3.44a1.22,1.22,0,0,0,.94-1.07l1.81-17.91a1.22,1.22,0,0,0-.71-1.24l-13.6-6.29a65.59,65.59,0,0,0-6.1-20.28l7.89-12.76a1.22,1.22,0,0,0-.09-1.42L1648.73,47.7a1.23,1.23,0,0,0-1.38-.38l-14.08,5.18a65.6,65.6,0,0,0-18.64-10l-3.43-14.59a1.26,1.26,0,0,0-1.08-.95l-17.9-1.81a1.24,1.24,0,0,0-1.25.71l-6.29,13.61a65.32,65.32,0,0,0-20.28,6.1l-12.75-7.9a1.23,1.23,0,0,0-1.43.09L1536.28,49.1a1.23,1.23,0,0,0-.38,1.38l5.18,14.08a65.24,65.24,0,0,0-10,18.64l-14.6,3.44a1.22,1.22,0,0,0-.94,1.07l-1.81,17.91a1.22,1.22,0,0,0,.7,1.24l13.61,6.29a65.59,65.59,0,0,0,6.1,20.28l-7.9,12.76a1.25,1.25,0,0,0,.1,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1593.16,123.92a19.34,19.34,0,1,1,2.86-.21A19.76,19.76,0,0,1,1593.16,123.92Zm.07-32a13.06,13.06,0,0,0-1.87.13,12.68,12.68,0,0,0,3.69,25.08h0A12.67,12.67,0,0,0,1593.23,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1593.51,148.89a43.17,43.17,0,0,1-4.52-.23h0a44.68,44.68,0,0,1-9.27-1.94,1.1,1.1,0,0,1-.77-1.05,1,1,0,0,1,.06-.34,1.09,1.09,0,0,1,1.39-.71,42.35,42.35,0,0,0,55.19-36c.14-1.45.21-2.88.21-4.3a42.32,42.32,0,0,0-84.43-4.23q-.21,2.15-.21,4.29a42.23,42.23,0,0,0,4,17.93,1.19,1.19,0,0,1,.11.47,1.1,1.1,0,0,1-2.1.47,44.28,44.28,0,0,1-4.21-18.87c0-1.5.08-3,.23-4.51a44.53,44.53,0,0,1,88.83,4.44c0,1.5-.08,3-.23,4.53A44.59,44.59,0,0,1,1593.51,148.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1089.93,807.88c-8.48-21.69-21.12-38.51-35-55.1a46.36,46.36,0,0,0-42.81-16c-75.7,12-179.87,22.38-226.17,28.21a66.1,66.1,0,0,0-41.61,22.51c-39.73,46-123.92,167-43.14,294.46a4.64,4.64,0,0,0,3.91,2.13h58.78l4.24-6.54c-17.1-38.08-14.71-79.81,4.42-125.62a4.65,4.65,0,0,1,8.72.39h0a800,800,0,0,1,29.09,127.79,4.62,4.62,0,0,0,4.57,4H994.5a4.62,4.62,0,0,0,4.56-3.83c16.56-94.46,60.87-196.53,75.4-228.51a28.93,28.93,0,0,1,14.33-14.43c2-.9,3.94-1.83,5.88-2.76a4.62,4.62,0,0,0,2.44-5.5C1095,821.93,1092.66,814.85,1089.93,807.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1249.67,710.44a9.92,9.92,0,0,1,.41-14.6l518.4-462.53a4.82,4.82,0,0,1,5.3-.76h0a4.84,4.84,0,0,1,1.18,7.92L1263.3,710.64a9.92,9.92,0,0,1-13.63-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M770,928.86c-15.33-44.13-12.13-95.29-11.1-107.32a2.57,2.57,0,0,1,2.85-2.32h0A2.56,2.56,0,0,1,764,822c-1,11.62-4.2,61.93,10.82,105.16a2.57,2.57,0,0,1-1.53,3.27h0A2.56,2.56,0,0,1,770,928.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1260.67,761.72c-72,26.33-233.7-24.89-233.7-24.89l-2.42,121.07c122.93,38.87,202.93,27.55,255-5.07C1282.74,815.75,1271.59,783.49,1260.67,761.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1375.37,632.27l-30.15-6s-8.22,95.93-75.37,131.39a74.19,74.19,0,0,1-9.18,4c10.92,21.77,22.07,54,18.83,91.11C1385.21,786.54,1375.37,632.27,1375.37,632.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1346.75,634.66l-1.53-8.36s-6.28-20.42,10.35-40.53c24-29.06,41-20.64,41-20.64s-.61,8.48-.53,14c.07,4.45,3.65,6.18,6.93,3.17l41-37.68s11,59.41-73.18,98.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M862.71,663.53l-5.41,94.28a5.8,5.8,0,0,0,4.35,6c12,3,45,9,73.83-7.35a9.4,9.4,0,0,0,4.28-10.72L915.69,661Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M937.65,567.5s26.37,60.57,28.14,92.36,8.62,52.42-28.14,58.83-67.72-11.91-84.5-43.58c0,0-26.28-48.8-20.39-68.78S937.65,567.5,937.65,567.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M865.71,652.34l2.09-.92a5,5,0,0,0,2.47-6.93c-5.18-10-15.29-33-2.23-38.32,16.82-6.9,83.46-20.49,97.84-44.14,13.82-22.73,1.57-52.06-16.83-60.41a2.53,2.53,0,0,0-3.31,1.08l-1.54,2.9a2.49,2.49,0,0,1-4.6-.47h0a2.49,2.49,0,0,0-4.5-.64c-4.42,7.07-16.35,18.54-48.26,24.43-45.35,8.37-75.33,26.72-76.08,58.06a2.5,2.5,0,0,1-3.87,2.06c-3.34-2-8.7-3-15.86,3-12.46,10.48-7.36,37.64,19.94,60a2.48,2.48,0,0,1-.12,4c-5,3.22-12.33,10.88,6.79,21.1,19.78,10.58,34.54,9.71,40.23,8.77a2.48,2.48,0,0,0,2-3l-6.07-27.55a2.5,2.5,0,0,1,2.44-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M866.85,658.15s-10.06-38.69-27.4-27.84,9,43.35,22.95,44.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 2034.57,
    cy: 671.27,
    r: 124.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 2035.56,
    cy: 670.06,
    r: 104.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1944,662.21l23.22-12.11v5.16a2,2,0,0,1-.29,1.07,2.38,2.38,0,0,1-1,.83l-10.64,5.46a10.61,10.61,0,0,1-1.42.6,16,16,0,0,1-1.6.45c.57.14,1.1.29,1.6.46a8.52,8.52,0,0,1,1.42.6l10.64,5.48a2.48,2.48,0,0,1,1,.84,2,2,0,0,1,.29,1.07v5.16L1944,665.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1977.79,683.44V639.86H1985v16.75a15,15,0,0,1,3.87-2.7,11.29,11.29,0,0,1,5-1,10.75,10.75,0,0,1,4.37.84,8.72,8.72,0,0,1,3.18,2.34,10.34,10.34,0,0,1,1.93,3.61,15.35,15.35,0,0,1,.66,4.62v19.15h-7.24V664.29a6.39,6.39,0,0,0-1.28-4.27,4.74,4.74,0,0,0-3.82-1.51,7.62,7.62,0,0,0-3.52.85,12.6,12.6,0,0,0-3.11,2.32v21.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M2021,683.91a7.9,7.9,0,0,1-6-2.22,8.47,8.47,0,0,1-2.11-6.11v-16.8h-3.05a1.47,1.47,0,0,1-1-.38,1.46,1.46,0,0,1-.43-1.15v-2.87l4.84-.79,1.52-8.21a1.43,1.43,0,0,1,.55-.91,1.69,1.69,0,0,1,1.07-.33h3.75v9.48h7.92v5.16h-7.92v16.3a3.19,3.19,0,0,0,.7,2.2,2.39,2.39,0,0,0,1.88.79,3.34,3.34,0,0,0,1.13-.16,6,6,0,0,0,.79-.34c.23-.11.43-.23.6-.33a1,1,0,0,1,.53-.17.84.84,0,0,1,.53.17,2.37,2.37,0,0,1,.44.48l2.17,3.52a11,11,0,0,1-3.64,2A13.51,13.51,0,0,1,2021,683.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M2033.82,683.44V653.35h4.43a1.79,1.79,0,0,1,1.85,1.32l.47,2.23a16.65,16.65,0,0,1,1.65-1.61,10.79,10.79,0,0,1,1.85-1.26,10,10,0,0,1,2.11-.84,9.62,9.62,0,0,1,2.48-.31,7.07,7.07,0,0,1,4.68,1.54,9.34,9.34,0,0,1,2.74,4.09,9.09,9.09,0,0,1,1.76-2.56,9.39,9.39,0,0,1,2.31-1.75,10.45,10.45,0,0,1,2.69-1,12.62,12.62,0,0,1,2.86-.33,11.94,11.94,0,0,1,4.42.77,8.49,8.49,0,0,1,3.26,2.22,9.84,9.84,0,0,1,2,3.58,15.58,15.58,0,0,1,.69,4.84v19.15h-7.25V664.29a6.45,6.45,0,0,0-1.26-4.33,4.65,4.65,0,0,0-3.69-1.45,5.64,5.64,0,0,0-2.07.38,5.22,5.22,0,0,0-1.67,1.1,4.94,4.94,0,0,0-1.13,1.81,7.06,7.06,0,0,0-.41,2.49v19.15h-7.27V664.29a6.57,6.57,0,0,0-1.22-4.4,4.53,4.53,0,0,0-3.59-1.38,5.78,5.78,0,0,0-2.92.78,9.8,9.8,0,0,0-2.53,2.13v22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2090.91,639.86v43.58h-7.24V639.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M2101.94,677.28v-5.16a2.07,2.07,0,0,1,.29-1.07,2.48,2.48,0,0,1,1-.84l10.64-5.48a14.38,14.38,0,0,1,3-1.06,15.82,15.82,0,0,1-1.59-.45,10.75,10.75,0,0,1-1.43-.6l-10.64-5.46a2.38,2.38,0,0,1-1-.83,2.07,2.07,0,0,1-.29-1.07V650.1l23.22,12.11v2.93Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1770.62,
    cy: 747.77,
    r: 102.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1771.44,
    cy: 746.77,
    r: 85.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1719.14,754.05v16.43h-8.68V723.8h15.2a26.74,26.74,0,0,1,8.11,1.1,15.52,15.52,0,0,1,5.65,3.07,12,12,0,0,1,3.29,4.71,16.45,16.45,0,0,1,1.07,6,16.67,16.67,0,0,1-1.13,6.22,13.11,13.11,0,0,1-3.39,4.86,15.84,15.84,0,0,1-5.65,3.16,25.28,25.28,0,0,1-7.95,1.13Zm0-6.78h6.52a13,13,0,0,0,4.17-.6,7.61,7.61,0,0,0,2.94-1.71,7,7,0,0,0,1.74-2.71,10.28,10.28,0,0,0,.58-3.57,9.42,9.42,0,0,0-.58-3.39,6.78,6.78,0,0,0-1.74-2.58,7.88,7.88,0,0,0-2.94-1.63,14,14,0,0,0-4.17-.56h-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1789.91,770.48h-8.75v-20.4h-21.89v20.4h-8.75V723.8h8.75v20.08h21.89V723.8h8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1808.31,754.05v16.43h-8.68V723.8h15.2a26.78,26.78,0,0,1,8.11,1.1,15.52,15.52,0,0,1,5.65,3.07,12,12,0,0,1,3.29,4.71,17.6,17.6,0,0,1-.07,12.22,12.88,12.88,0,0,1-3.39,4.86,15.75,15.75,0,0,1-5.65,3.16,25.22,25.22,0,0,1-7.94,1.13Zm0-6.78h6.52a13.1,13.1,0,0,0,4.17-.6,7.5,7.5,0,0,0,2.93-1.71,6.94,6.94,0,0,0,1.75-2.71,10.28,10.28,0,0,0,.58-3.57,9.42,9.42,0,0,0-.58-3.39,6.69,6.69,0,0,0-1.75-2.58,7.76,7.76,0,0,0-2.93-1.63,14.08,14.08,0,0,0-4.17-.56h-6.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1502.88,
    cy: 626.29,
    r: 94.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1503.63,
    cy: 625.37,
    r: 79.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1484.17,636a1.69,1.69,0,0,1,1.26.56l3.49,3.79a19.06,19.06,0,0,1-7.13,5.5,24.54,24.54,0,0,1-10.17,1.92,24,24,0,0,1-9.54-1.82,21,21,0,0,1-7.23-5,22.08,22.08,0,0,1-4.6-7.71,29.08,29.08,0,0,1-1.59-9.78,26.3,26.3,0,0,1,1.78-9.84,22.39,22.39,0,0,1,5-7.69,22.83,22.83,0,0,1,7.73-5,26.71,26.71,0,0,1,9.93-1.79,23.5,23.5,0,0,1,9.28,1.69,21.85,21.85,0,0,1,6.8,4.5l-3,4.12a2.62,2.62,0,0,1-.68.69,1.89,1.89,0,0,1-1.14.3,2.59,2.59,0,0,1-1.54-.59,18.76,18.76,0,0,0-2-1.29,16.36,16.36,0,0,0-3.08-1.28,15.74,15.74,0,0,0-4.73-.6,16,16,0,0,0-6.18,1.17,13.71,13.71,0,0,0-4.84,3.35,15.42,15.42,0,0,0-3.17,5.29,20.44,20.44,0,0,0-1.13,7,21.08,21.08,0,0,0,1.13,7.15,15.94,15.94,0,0,0,3.08,5.27,13.26,13.26,0,0,0,4.58,3.28,14.31,14.31,0,0,0,5.67,1.13,25.11,25.11,0,0,0,3.28-.19,14.06,14.06,0,0,0,2.7-.63,12.21,12.21,0,0,0,2.34-1.1,14.79,14.79,0,0,0,2.19-1.67,3.07,3.07,0,0,1,.69-.48A1.76,1.76,0,0,1,1484.17,636Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1513.13,608.59V622.1H1526v6h-12.82V641.7h-6.59V628.13h-12.75v-6h12.75V608.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1551.35,608.59V622.1h12.82v6h-12.82V641.7h-6.59V628.13H1532v-6h12.75V608.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1849.72,442.75l51.07,69.93-22.38,16.39a2.42,2.42,0,0,0,.79,4.28l74.1,20.56a3,3,0,0,0,3.75-3.06l-4.76-69.08a2.25,2.25,0,0,0-3.65-1.6l-20.4,16.25L1869.71,429a3.69,3.69,0,0,0-4.94-.58l-14.4,10.3A2.9,2.9,0,0,0,1849.72,442.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1780.16,459.31,1776.29,554l24-.41a2.09,2.09,0,0,1,1.58,3.41l-42,51.41a2.56,2.56,0,0,1-4.17-.29l-31.05-51.1a1.94,1.94,0,0,1,1.78-2.95l22.49,1.3,2.73-96.07a3,3,0,0,1,3-2.94h22.74A2.8,2.8,0,0,1,1780.16,459.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1661,435l-50.45,72.53,19.06,11.68a2,2,0,0,1-.47,3.48l-58.78,19.37a2.38,2.38,0,0,1-3.13-2.31l1.16-55.72a1.82,1.82,0,0,1,2.88-1.43l17,12.28,50.24-74.16a2.81,2.81,0,0,1,3.85-.79l17.88,11.38A2.6,2.6,0,0,1,1661,435Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1554.94,303.92l-48.12,4.94,3.3,20.42a1.81,1.81,0,0,1-2.72,1.77l-49.05-29.57a2.21,2.21,0,0,1-.26-3.59l39.8-32.79a1.68,1.68,0,0,1,2.74,1.16l1.65,19.35,49.44-5.69a1.62,1.62,0,0,1,1.78,1.32l3.69,19.67A2.55,2.55,0,0,1,1554.94,303.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.88,1303H520.06v-69.38H120.88C129.42,1233.63,129.42,1303,120.88,1303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M520.06,1285.65V1253.9c0-11.19-7.89-20.27-17.62-20.27H122.56c-7.65,0-13.85-5.38-13.85-12a4,4,0,0,1,4.21-3.65H528.09c9.52,0,24.64,13,24.64,29v44.34c0,15.12-14.67,27.38-23.65,27.38h-414c-3.53,0-6.39-2.49-6.39-5.56,0-5.59,5.22-10.13,11.67-10.13H505C513.3,1303,520.06,1295.24,520.06,1285.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M509,1248.86H134.7a1,1,0,1,1,0-2H509a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M509,1259.16H134.7a1,1,0,0,1,0-2H509a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M509,1269.45H134.7a1,1,0,1,1,0-2H509a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M509,1279.75H134.7a1,1,0,1,1,0-2H509a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M509,1290.05H134.7a1,1,0,1,1,0-2H509a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    y: 1317.96,
    width: 532.76,
    height: 115.92,
    rx: 21.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 60.21,
    y: 1331.28,
    width: 62.59,
    height: 89.28,
    rx: 7.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 132,
    y: 1331.28,
    width: 23.48,
    height: 89.28,
    rx: 5.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M571.63,1161h.3l126.46-.13a5.65,5.65,0,1,0,0-11.3l-126.46.13a5.65,5.65,0,0,0-.28,11.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M747.36,1037.2l-.13.26L694,1152.18a5.65,5.65,0,1,0,10.26,4.75l53.21-114.72a5.65,5.65,0,0,0-10.13-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M627.94,1167.39c-.55,2.29-53.32,200.19-66.69,250.36a9.06,9.06,0,0,0,8.68,11.46h0a9,9,0,0,0,8.72-6.89l58.58-237.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M656.84,1167.39c.55,2.29,53.32,200.19,66.7,250.36a9.07,9.07,0,0,1-8.68,11.46h0a9,9,0,0,1-8.73-6.89l-58.57-237.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M659,1160.92H626.17v26.39a6.83,6.83,0,0,0,6.79,6.87h4.51v59.28a5.17,5.17,0,0,0,5.14,5.2h0a5.17,5.17,0,0,0,5.13-5.2v-59.28H650a9.06,9.06,0,0,0,9-9.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M545.37,1154.58h183.5a5.64,5.64,0,0,1,5.45,4.27l2.56,10a5.68,5.68,0,0,1-5.48,7.12l-188.29-1.1a5.68,5.68,0,0,1-5.42-7.08l2.23-8.95A5.62,5.62,0,0,1,545.37,1154.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M552.43,1419.63c-20.81,0-30-1.79-34.14-3.42a7.9,7.9,0,0,0,7.69,6.12H599.6a3.59,3.59,0,0,0,3.46-4.52C594.66,1418.48,576.84,1419.63,552.43,1419.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M603.06,1417.81a3.5,3.5,0,0,0-.61-1.26c-5.6-7.15-16.87-18.4-32.19-18.18-22.45.31-30.28,2.75-47.73.13l-4.11,13.64a7.85,7.85,0,0,0-.13,4.07c4.12,1.63,13.33,3.42,34.14,3.42C576.84,1419.63,594.66,1418.48,603.06,1417.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M527.58,1383.8,522.53,1401s11.19,5.1,21,1l1.93-14.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M680.17,1408.81c-16.22,13-24.51,17.41-28.73,18.73a7.88,7.88,0,0,0,9.8-.07l57.39-46.12a3.56,3.56,0,0,0-.12-5.67C712.39,1381.46,699.2,1393.52,680.17,1408.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M718.51,1375.68a3.52,3.52,0,0,0-1.25-.59c-8.84-2-24.63-3.71-36.44,6.06-17.31,14.3-21.89,21.09-37.12,30l5.3,13.16a7.7,7.7,0,0,0,2.44,3.24c4.22-1.32,12.51-5.7,28.73-18.73C699.2,1393.52,712.39,1381.46,718.51,1375.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M419.51,1188.05s124.6,10.17,150.16,22.2-20.86,180.67-20.86,180.67-7,3.35-22.44-1.46c0,0,15.88-124.45,4.06-151.44L395.53,1216Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M631.32,1387.45c1.16,1.06,12.38,23.69,12.38,23.69s12.5-2.7,15-10.61L647.5,1380.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M344.47,1187a63.07,63.07,0,0,0-3.89,22.76,34.16,34.16,0,0,0,32.6,33.42l147.29,6.71a7.08,7.08,0,0,1,6.52,5.31c3.46,13.39,20.38,54.5,103.08,136.54a6.67,6.67,0,0,0,8.24.9l11.78-7.44a2.71,2.71,0,0,0,.89-3.66l-85.76-146.45a33.21,33.21,0,0,0-20.17-14.95l-125.54-32.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M515.34,961.53s-41.49,24.61-57.58,38.12L491,1018.2s18-20.75,35.09-29.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M341.8,1188.05s39.76,9.69,77.71,0c0,0,53.11-71.4,73.66-90.83,0,0,39.31,52.41,114.16,54.76l-5.89-7.54s-56.56-24-74.43-65.17-25.06-58.68-41.33-69.41c-10.13-6.68-16.19-11.25-19.33-13.74a5.18,5.18,0,0,0-6-.38C443.13,1006.26,361.91,1061.89,341.8,1188.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M490.62,1094a159.78,159.78,0,0,1-19.72-35l.92-.36a158.41,158.41,0,0,0,19.59,34.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M599.08,1145.07l8.21-2.19,24.93-5.77a11.53,11.53,0,0,1,8.76,1.48l21.44,13.48-59.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M555.73,942.15c.13.86-11.37,57.2-11.37,57.2l-32-7.25,3-55S553.66,927.74,555.73,942.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M522.5,949.35l-3.83,28.83a3.75,3.75,0,0,0,0,1.11c.32,2.26,2,10,9.77,7.75,7-2,13.51-3.71,18-2.34a4.05,4.05,0,0,1,2.79,4.69,174.18,174.18,0,0,1-7.37,26.25,4,4,0,0,1-4.92,2.4c-6.08-1.77-18.78-5.86-28.23-11.55a4.06,4.06,0,0,1-2-3.66c.3-7.28,1.15-29.41.44-35.61-.67-5.83-7.82-9.31-10.93-10.57a4,4,0,0,1-2.22-2.23c-1.44-3.6-3.42-11.94,7.09-15.35a4.08,4.08,0,0,0,2.58-5.27c-1.56-4.33-2.22-10.94,5.91-14.58s14.43.7,17.76,4.28a4.06,4.06,0,0,0,5.18.61,3.22,3.22,0,0,1,3.66.12,4,4,0,0,0,5.67-1.71c2-4.06,6-8.41,14.1-7,14.35,2.46,16,18.36,12.19,27.68s-19.19,5.77-26.92,1.07c-5.88-3.57-13.5.18-16.82,2.18A4,4,0,0,0,522.5,949.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M505.87,977.73s5.9-16.52-.16-20.57-15-1.94-13.07,10C495.1,982.07,505.87,977.73,505.87,977.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1249.8,889.26l1.57,2.52a.52.52,0,0,1-.16.73.53.53,0,0,1-.73-.16v0l-1.53-2.55a.5.5,0,0,1,.85-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1255.1,897.63l1.62,2.48a.64.64,0,0,1-1.06.7h0l-1.57-2.53a.6.6,0,0,1,1-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1260.55,905.89l1.67,2.46a.73.73,0,0,1-.19,1,.73.73,0,0,1-1-.19h0l-1.63-2.5a.7.7,0,1,1,1.17-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1266.16,914.05l1.72,2.42h0a.8.8,0,0,1-1.31.93h0l-1.68-2.45a.78.78,0,0,1,1.28-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1272,922.05l1.78,2.37h0a.89.89,0,1,1-1.42,1.06h0l-1.75-2.41a.86.86,0,0,1,1.38-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1278,929.88l1.86,2.31h0a1,1,0,1,1-1.5,1.21h0l-1.83-2.36a.94.94,0,0,1,1.47-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1284.27,937.52l1.93,2.25h0a1,1,0,0,1-1.59,1.37v0l-1.91-2.29a1,1,0,0,1,1.56-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1290.79,944.94l2,2.19h0a1.1,1.1,0,0,1-.07,1.57,1.12,1.12,0,0,1-1.57-.07h0l-2-2.23a1.1,1.1,0,0,1,1.63-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1297.54,952.14l2.07,2.11h0a1.16,1.16,0,0,1-1.65,1.63h0l-2.07-2.15a1.15,1.15,0,1,1,1.64-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1304.55,959.08l2.16,2h0a1.21,1.21,0,0,1-1.65,1.77h0l-2.16-2.07a1.19,1.19,0,0,1,1.64-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1311.85,965.71l2.24,1.93h0a1.26,1.26,0,1,1-1.64,1.91h0l-2.25-2a1.24,1.24,0,0,1,1.62-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1319.43,972l2.33,1.82h0a1.3,1.3,0,0,1,.23,1.83,1.32,1.32,0,0,1-1.84.23h0l-2.34-1.86a1.29,1.29,0,0,1,1.6-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1327.3,977.92l2.42,1.7h0a1.35,1.35,0,1,1-1.55,2.22h0l-2.44-1.74a1.34,1.34,0,0,1,1.55-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1335.46,983.41,1338,985h0a1.41,1.41,0,1,1-1.48,2.39h0l-2.53-1.6a1.39,1.39,0,0,1,1.47-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1343.92,988.4l2.6,1.4h0a1.45,1.45,0,1,1-1.37,2.56h0l-2.63-1.44a1.44,1.44,0,0,1,1.37-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1352.67,992.85l2.68,1.22h0a1.5,1.5,0,1,1-1.24,2.73h0l-2.73-1.27a1.49,1.49,0,0,1,1.25-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1361.69,996.7l2.76,1h0a1.52,1.52,0,1,1-1.07,2.84h0l-2.82-1.06a1.52,1.52,0,0,1,1.07-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1371,999.89l2.82.82h0a1.54,1.54,0,0,1-.86,2.95h0l-2.89-.85a1.53,1.53,0,1,1,.86-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1380.42,1002.35l2.88.58h0a1.55,1.55,0,0,1-.62,3h0l-3-.61a1.55,1.55,0,1,1,.63-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1390.06,1004l2.91.35h0a1.57,1.57,0,0,1-.37,3.12h0l-3-.37a1.56,1.56,0,0,1,.37-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1399.8,1004.88l2.93.11h0a1.59,1.59,0,0,1-.12,3.17h0l-3-.12a1.58,1.58,0,0,1,.13-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1409.58,1005l2.94-.11h0a1.6,1.6,0,0,1,.13,3.19h0l-3,.11a1.6,1.6,0,0,1-.12-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1419.35,1004.36l2.93-.33h0a1.61,1.61,0,0,1,.35,3.21h0l-3,.32a1.61,1.61,0,0,1-.34-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1429.07,1003.06l2.89-.51h0a1.64,1.64,0,0,1,.57,3.22h0l-3,.51a1.63,1.63,0,0,1-.56-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1438.69,1001.15l2.86-.68h0a1.65,1.65,0,1,1,.76,3.21h0l-2.92.68a1.64,1.64,0,1,1-.75-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1448.19,998.69l2.83-.84h0a1.65,1.65,0,0,1,2.06,1.12A1.67,1.67,0,0,1,1452,1001h0l-2.87.84a1.66,1.66,0,1,1-.93-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1457.57,995.74l2.78-1h0a1.68,1.68,0,1,1,1.1,3.17h0l-2.83,1a1.68,1.68,0,0,1-1.1-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1466.8,992.35l2.75-1.09h0a1.69,1.69,0,0,1,1.24,3.14L1468,995.5a1.69,1.69,0,0,1-1.25-3.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1475.9,988.6l2.7-1.2h0a1.67,1.67,0,0,1,1.36,3.05l-2.73,1.22a1.68,1.68,0,1,1-1.37-3.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1484.86,984.5l2.66-1.29h0a1.67,1.67,0,0,1,2.22.77,1.65,1.65,0,0,1-.77,2.21l-2.68,1.32a1.66,1.66,0,1,1-1.46-3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1493.68,980.1l2.62-1.38h0a1.65,1.65,0,1,1,1.54,2.91l-2.65,1.4a1.65,1.65,0,0,1-1.54-2.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1502.37,975.42,1505,974h0a1.63,1.63,0,0,1,1.6,2.84l-2.6,1.47a1.64,1.64,0,0,1-1.61-2.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1510.94,970.52l2.55-1.51h0a1.62,1.62,0,0,1,1.65,2.78l-2.57,1.53a1.62,1.62,0,0,1-1.65-2.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1519.42,965.44l2.52-1.55h0a1.6,1.6,0,0,1,1.68,2.73l-2.53,1.56a1.61,1.61,0,1,1-1.69-2.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1527.82,960.23l2.51-1.59h0a1.59,1.59,0,1,1,1.71,2.68l-2.52,1.6a1.59,1.59,0,0,1-1.71-2.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1536.17,954.91l2.49-1.61a1.58,1.58,0,0,1,1.72,2.64l-2.5,1.62a1.58,1.58,0,1,1-1.72-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1544.48,949.52l2.49-1.62a1.56,1.56,0,1,1,1.71,2.61l-2.49,1.63a1.56,1.56,0,0,1-2.17-.45,1.58,1.58,0,0,1,.45-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1552.77,944.1l2.49-1.63a1.57,1.57,0,0,1,2.15.45,1.55,1.55,0,0,1-.45,2.14l-2.48,1.64a1.56,1.56,0,1,1-1.71-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1561.08,938.68l2.49-1.62a1.54,1.54,0,0,1,1.68,2.58l-2.49,1.62a1.54,1.54,0,1,1-1.69-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1569.41,933.3l2.51-1.6a1.52,1.52,0,1,1,1.64,2.56l-2.5,1.6a1.53,1.53,0,0,1-1.66-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1577.8,928l2.53-1.57a1.51,1.51,0,0,1,1.59,2.56h0l-2.51,1.58h0a1.51,1.51,0,0,1-1.61-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1586.26,922.79l2.56-1.53a1.47,1.47,0,0,1,1.53,2.52h0l-2.53,1.54h0a1.49,1.49,0,0,1-1.55-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1594.83,917.75l2.6-1.48a1.42,1.42,0,0,1,2,.53,1.44,1.44,0,0,1-.52,2h0l-2.57,1.49h0a1.45,1.45,0,0,1-1.45-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1603.52,912.88l2.62-1.41a1.39,1.39,0,1,1,1.33,2.44h0l-2.59,1.43h0a1.41,1.41,0,0,1-1.91-.56,1.4,1.4,0,0,1,.56-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1612.33,908.25l2.68-1.33a1.35,1.35,0,0,1,1.21,2.41h0l-2.64,1.34h0a1.37,1.37,0,0,1-1.83-.61,1.35,1.35,0,0,1,.6-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1621.36,904l2.77-1.17a1.3,1.3,0,0,1,1,2.4l0,0-2.71,1.16,0,0a1.32,1.32,0,1,1-1.05-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1630.7,900.36l2.87-.92a1.27,1.27,0,0,1,.78,2.41h0l-2.78.92h0a1.28,1.28,0,0,1-.8-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1640.4,897.69l3-.56a1.22,1.22,0,0,1,.46,2.4h0l-2.87.57h-.06a1.24,1.24,0,0,1-.47-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1650.4,896.35l3-.08a1.18,1.18,0,0,1,.07,2.36h-.06l-2.91.1h-.06a1.2,1.2,0,1,1-.09-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1660.52,896.77l3,.52a1.13,1.13,0,0,1,.94,1.31,1.15,1.15,0,0,1-1.31.94h-.07l-2.87-.47-.06,0a1.15,1.15,0,1,1,.37-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1670.35,899.15l2.83,1.06a1.1,1.1,0,0,1-.76,2.07l-.05,0-2.74-1-.06,0a1.11,1.11,0,0,1,.77-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1679.55,903.27l2.61,1.53a1,1,0,0,1-1,1.79l0,0-2.55-1.44,0,0a1,1,0,0,1-.4-1.43,1.05,1.05,0,0,1,1.44-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1687.94,908.82l2.34,1.9a1,1,0,0,1-1.2,1.5l0,0-2.3-1.81,0,0a1,1,0,0,1,1.22-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1695.41,915.53l2,2.2a.88.88,0,0,1-1.28,1.22l0,0-2-2.12,0,0a.9.9,0,0,1,0-1.28.91.91,0,0,1,1.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1701.88,923.18l1.73,2.45a.81.81,0,0,1-.19,1.13.8.8,0,0,1-1.12-.18l0,0-1.74-2.37,0,0a.83.83,0,0,1,.18-1.16.84.84,0,0,1,1.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1707.28,931.6l1.41,2.65a.74.74,0,0,1-1.3.7v0l-1.42-2.58v0a.76.76,0,1,1,1.33-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1711.56,940.63l1.06,2.81a.68.68,0,0,1-.39.86.66.66,0,0,1-.85-.38v0l-1.08-2.74v0a.69.69,0,0,1,1.28-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1714.63,950.14l.68,2.93a.59.59,0,0,1-1.15.27v0l-.7-2.86v0a.61.61,0,0,1,1.19-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1716.41,960l.26,3a.52.52,0,0,1-.47.56.51.51,0,0,1-.55-.46v0l-.3-2.93v0a.54.54,0,0,1,.48-.59.55.55,0,0,1,.6.48Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BProject1);
export default __webpack_public_path__ + "static/media/b2b_project_1.a36f865fad824203b0c6029f5bd99d2d.svg";
export { ForwardRef as ReactComponent };